import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Progress } from "../components/ui/progress";
import { StatusBadge } from "../components/StatusBadge";
import { ChevronLeft } from "lucide-react";
import { ROLE_LABEL, TASK_STATUS_LABEL, TASK_PRIORITY_LABEL } from "../lib/constants";
import { formatDate } from "../lib/format";

export default function EmployeeDetail() {
  const { id } = useParams();
  const [e, setE] = useState(null);
  useEffect(() => { api.get(`/employees/${id}`).then(({ data }) => setE(data)); }, [id]);
  if (!e) return <div className="text-sm text-[#8C9096]">Memuat...</div>;
  return (
    <div className="space-y-6" data-testid="employee-detail">
      <Link to="/employees" className="text-sm text-[#5C6066] hover:text-brand inline-flex items-center gap-1"><ChevronLeft className="w-4 h-4" /> Kembali</Link>
      <Card className="p-6 border border-[#E5E0D8] bg-white shadow-none">
        <h1 className="font-display text-2xl font-bold">{e.name}</h1>
        <div className="text-sm text-[#5C6066]">{e.email} • {ROLE_LABEL[e.role]} • {e.division?.name || "—"}</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-6 border-t border-[#F0EBE0]">
          <Kpi label="Total Tugas" value={e.stats?.tasks_total} />
          <Kpi label="Selesai" value={e.stats?.tasks_done} tone="success" />
          <Kpi label="Overdue" value={e.stats?.tasks_overdue} tone="danger" />
          <Kpi label="Bukti Diunggah" value={e.stats?.evidence_uploads} />
        </div>
      </Card>
      <Card className="border border-[#E5E0D8] bg-white shadow-none">
        <div className="px-5 py-4 border-b border-[#E5E0D8] font-display font-semibold">Riwayat Tugas</div>
        <div className="divide-y divide-[#F0EBE0] max-h-[500px] overflow-y-auto">
          {(e.recent_tasks || []).map((t) => (
            <div key={t.id} className="px-5 py-3 flex items-start justify-between">
              <div>
                <div className="text-sm font-medium">{t.title}</div>
                <div className="text-[11px] text-[#8C9096]">Jatuh tempo {formatDate(t.due_date)}</div>
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge status={t.priority} label={TASK_PRIORITY_LABEL[t.priority]} />
                <StatusBadge status={t.status} label={TASK_STATUS_LABEL[t.status]} />
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
const Kpi = ({ label, value, tone }) => (
  <div>
    <div className="text-xs uppercase text-[#8C9096]">{label}</div>
    <div className={`mt-1 font-display text-xl font-bold ${tone === "success" ? "text-emerald-700" : tone === "danger" ? "text-rose-700" : ""}`}>{value ?? 0}</div>
  </div>
);
